import * as React from "react";

import { appendToClassName } from "lib/helpers";

interface Props {
  title: string;
  menuTitle: string;
  subtitle: string;
  children: React.ReactNode;
  className: string;
  externalRef: React.RefObject<HTMLDivElement>;
  minimumVersion: number;
}

export class ValuationSection extends React.Component<Props> {
  protected className: string;
  protected title: string;

  public constructor(props: Props) {
    super(props);
    this.className = props.className;
    this.title = props.title;
  }

  public render() {
    const { title, subtitle, children, className, externalRef } = this.props;

    return (
      <>
        <div className={`${className} valuation-section`} ref={externalRef}>
          <h1>{title}</h1>
          <label>{subtitle}</label>
          <div
            className={appendToClassName(
              "horizontal-separator-container",
              className,
            )}
          >
            <div className="horizontal-separator colored-section-separator separator" />
          </div>
          <div className="valuation-section-body">{children}</div>
        </div>
      </>
    );
  }
}
